import { Skeleton } from "antd";
import { ReactElement } from "react";
import { ReaderTopic } from "../../types/helpCentre.types";
import TopicCard from "./TopicCard";

interface TopicGridProps {
	/** Undefined while loading. */
	topics?: ReaderTopic[];
	/** What shows when there are no topics. */
	empty?: ReactElement;
	/** How many placeholder cards show while loading. */
	skeletonCount?: number;
}

/** Topic cards in a grid, placeholders while they load, or `empty` when there are none. */
function TopicGrid({
	topics,
	empty,
	skeletonCount = 6,
}: Readonly<TopicGridProps>) {
	if (!topics) {
		return (
			<div className="help-topic-grid" aria-busy="true">
				{Array.from({ length: skeletonCount }, (_, index) => (
					<div
						key={index} // NOSONAR: identical placeholders that never reorder
						className="help-topic-card help-topic-card--skeleton"
					>
						<Skeleton.Avatar active shape="square" size={44} />
						<Skeleton
							active
							title={{ width: "70%" }}
							paragraph={{ rows: 1, width: "40%" }}
						/>
					</div>
				))}
			</div>
		);
	}
	if (!topics.length) return empty ?? null;
	return (
		<ul className="help-topic-grid">
			{topics.map((topic) => (
				<li key={topic.key}>
					<TopicCard topic={topic} />
				</li>
			))}
		</ul>
	);
}

export default TopicGrid;
